<footer class="footer">
    <h2 class="service-name">{{ serviceName | titlecase }}</h2>
    <nav class="footer-menu">
        <ul>
            <li><a href="#" i18n="Text for the link to the terms and conditions in the footer@@T&C">Terms & Conditions</a></li>
            <li><a href="#" i18n="Text for the link to the privacy settings in the footer@@PRIVACY_SETTINGS">Privacy settings</a></li>
        </ul>
    </nav>
</footer>